import { useTranslation } from "react-i18next"
import PageLayout from "components/layout/PageLayout"
import { useArchiveAllNotificationsMutation, useArchiveNotificationMutation, useGetAllNotificationsQuery, useMarkNotificationAsReadMutation, useMarksAllNotificationsAsReadMutation } from "./api/notificationApiSlice"
import NotificationCard from "./components/NotificationCard"
import PaginationBar from "components/widget/PaginationBar"
import { useEffect, useState } from "react"
import NoData from "components/commons/NoData"

const Notifications = () => {

    const [t, i18n] = useTranslation(["global"])
    const [requestPage, setRequestPage] = useState(0)
    const [showArchived, setShowArchived] = useState(false)

    const {
        data: response,
        isFetching,
        isSuccess,
        isError,
        error,
        refetch
    } = useGetAllNotificationsQuery({ showArchived: showArchived, pageNumber: requestPage })

    const [
        archiveRequest,
        {
            isLoading: archivingIsLoading
        },
        archivingResult
    ] = useArchiveNotificationMutation()

    const [markAsRead] = useMarkNotificationAsReadMutation()

    const [archiveAll] = useArchiveAllNotificationsMutation()

    useEffect(() => {
        refetch()
    }, [showArchived])

    const handleArchive = (guid) => {
        console.log(`The notification (${guid}) will be ARCHIVED`);
        archiveRequest(guid)
    }

    let content

    if (isSuccess) {

        let newItem = {

            "guid": "3cbeb79c-5264-46d2-9b79-f209e03309c7",
            "userGuid": "2312c029-0871-4625-90a2-e91d2b130eb2",
            "isRead": true,
            "isArchived": false,
            "title": "Welcome",
            "content": "Your are welcome",
            "subjectType": null,
            "subjectGuid": null,
            "timestamp": 1706122704530
        }

        content =
            <>

                <div className="row p-2">
                    <div className="col-auto">
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" value="" onChange={() => setShowArchived(!showArchived)} checked={showArchived} id="flexCheckDefault" />
                            <label className="form-check-label" htmlFor="flexCheckDefault">
                                {t("helper.show_archived")}
                            </label>
                        </div>

                    </div>
                    <div className="col text-end">
                        <button className="btn btn-primary" onClick={archiveAll}><i className="fa-solid fa-box-archive"></i> Archivia tutte</button>
                    </div>
                </div>

                <div className="row row-cols-sm-1">
                    <div className="col-auto">
                        {
                            response.content.map(notify => (

                                <NotificationCard
                                    key={notify.guid}
                                    notification={notify}
                                    onNotificationArchived={handleArchive}
                                    onNotificationRead={markAsRead}
                                />

                            ))
                        }
                        {
                            response.content.length == 0 && <NoData message={t("helper.no_notifications_yet")} />
                        }
                    </div>

                </div>

                <PaginationBar
                    currentPage={requestPage + 1}
                    postsPerPage={response.pageable.pageSize}
                    totalPosts={response.totalElements}
                    paginate={(e) => {
                        setRequestPage(e - 1)
                    }}
                />
            </>
    }

    return <PageLayout
        pageTitle={t("menu.notifications")}
        onPageRefresh={refetch}
        isLoadingContent={isFetching || archivingIsLoading}
        bodyContent={content}
    />
}

export default Notifications